import { ReactNode } from 'react'
import Header from './Header'
import Footer from './Footer'
import StickyCTA from './StickyCTA'
import CookieConsent from './CookieConsent'

interface LayoutProps {
  children: ReactNode
}

function Layout({ children }: LayoutProps) {
  return (
    <div className="layout">
      <Header />
      <main>{children}</main>
      <Footer />
      <StickyCTA />
      <CookieConsent />
    </div>
  )
}

export default Layout
